var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2.66667C4 1.19391 5.19391 0 6.66667 0H9.33333C10.8061 0 12 1.19391 12 2.66667H15.3333C15.7015 2.66667 16 2.96514 16 3.33333C16 3.70152 15.7015 4 15.3333 4H14.6342L14.2242 12.1997C14.1177 14.3286 12.3607 16 10.2292 16H5.77083C3.63933 16 1.88226 14.3286 1.77582 12.1998L1.36583 4H0.666667C0.298477 4 0 3.70152 0 3.33333C0 2.96514 0.298477 2.66667 0.666667 2.66667H4ZM2.70083 4L3.10749 12.1332C3.17845 13.5524 4.34983 14.6667 5.77083 14.6667H10.2292C11.6502 14.6667 12.8215 13.5524 12.8925 12.1332L13.2992 4H2.70083ZM10.6667 2.66667H5.33333C5.33333 1.93029 5.93029 1.33333 6.66667 1.33333H9.33333C10.0697 1.33333 10.6667 1.93029 10.6667 2.66667ZM6 6.66667C6.36819 6.66667 6.66667 6.96514 6.66667 7.33333V10.6667C6.66667 11.0349 6.36819 11.3333 6 11.3333C5.63181 11.3333 5.33333 11.0349 5.33333 10.6667V7.33333C5.33333 6.96514 5.63181 6.66667 6 6.66667ZM10 6.66667C10.3682 6.66667 10.6667 6.96514 10.6667 7.33333V10.6667C10.6667 11.0349 10.3682 11.3333 10 11.3333C9.63181 11.3333 9.33333 11.0349 9.33333 10.6667V7.33333C9.33333 6.96514 9.63181 6.66667 10 6.66667Z",
    fill: "#F7F9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.eb11a85dd405a47d3f948d23c47b9d11.svg";
export { ForwardRef as ReactComponent };